import { Component, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { ZaiksService } from 'src/app/services/zaiks.service';
export interface IRangeDateZaiks {
  dateFrom: Date;
  dateTo: Date;
}

@Component({
  selector: 'app-zaiks',
  templateUrl: './zaiks.component.html',
  styleUrls: ['./zaiks.component.scss']
})


export class ZaiksComponent implements OnInit {
  public rangeDate: IRangeDateZaiks;

  constructor(private zaiksService: ZaiksService) {
    this.rangeDate = {
      dateFrom: null,
      dateTo: null
    }
   }

  ngOnInit(): void {
  }

  fixDate() {
    const dateFrom = this.rangeDate.dateFrom;
    const dateTo = this.rangeDate.dateTo;
    this.rangeDate.dateFrom = new Date(Date.UTC(dateFrom.getFullYear(),dateFrom.getMonth(),dateFrom.getDate()));
    this.rangeDate.dateTo = new Date(Date.UTC(dateTo.getFullYear(),dateTo.getMonth(),dateTo.getDate()));
  }
  
  public getReport() {
    this.fixDate();
    this.zaiksService.getReportZaiks(this.rangeDate).subscribe(response => {
      saveAs(response);
    });
  }

}
